export const sentRequestsConstants = {
    SENT_REQUESTS_FETCH: 'SENT_REQUESTS_FETCH',
    SENT_REQUESTS_SUCCESS: 'SENT_REQUESTS_SUCCESS',
    SENT_REQUESTS_ERROR: 'SENT_REQUESTS_ERROR',
};
